import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  alignItems: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  direction: PropTypes.string,
  justifyContent: PropTypes.string,
};

const defaultProps = {
  alignItems: 'stretch',
  children: undefined,
  className: undefined,
  direction: 'row',
  justifyContent: 'flex-start',
};

function FlexBox({ alignItems, children, className, direction, justifyContent }) {
  return (
    <div
      className={className}
      style={{
        alignItems,
        display: 'flex',
        flexDirection: direction,
        minWidth: 0, // flexbox hack
        justifyContent,
      }}
    >
      {children}
    </div>
  );
}

FlexBox.propTypes = propTypes;
FlexBox.defaultProps = defaultProps;

export default FlexBox;
